import { UserRole } from '../generated/graphql';
import { useAppSelector } from '../store/store';

export function useUserRole() {
  const roles = useAppSelector((state) => state.user.roles);

  // Indicates whether roles have been loaded from the auth state
  // Null/undefined means not yet loaded, empty array means loaded but no roles
  const isRolesLoaded = roles !== null && roles !== undefined;

  const hasRole = (role: UserRole) => roles?.includes(role) ?? false;

  const isTraveler = hasRole(UserRole.ClientTraveler);
  const isClientAdmin = hasRole(UserRole.ClientAdmin);
  const isClientUser = hasRole(UserRole.ClientUser);
  const isClientReadOnly = hasRole(UserRole.ClientReadOnly);

  // A user is "only a traveler" if they have CLIENT_TRAVELER but no higher client roles
  // CLIENT_ADMIN, CLIENT_USER, or CLIENT_READ_ONLY can see full views even if they also have traveler role
  const isOnlyTraveler =
    isTraveler && !isClientAdmin && !isClientUser && !isClientReadOnly;

  // Derived permissions - only pure travelers have restricted access
  const canViewFullRoster = !isOnlyTraveler;
  const canViewAllGuests = !isOnlyTraveler;
  const canViewCosts = !isOnlyTraveler;
  const canBookMultipleRooms = !isOnlyTraveler;
  const canCreateGroupRequests = !isOnlyTraveler;
  const canSelectGuests = !isOnlyTraveler;

  return {
    roles,
    isRolesLoaded,
    hasRole,
    isTraveler,
    isOnlyTraveler,
    isClientAdmin,
    isClientUser,
    isClientReadOnly,
    canViewFullRoster,
    canViewAllGuests,
    canViewCosts,
    canBookMultipleRooms,
    canCreateGroupRequests,
    canSelectGuests,
  };
}
